<template>
  <div class="liu-xuan-question-list">
    <img class="header"
         :src="require('@/assets/img/liuxuan-psychology/question_header.png')"
         alt=""
    />
    <div class="question-list">
      <div class="question-item"
           v-for="(item, index) in list"
           :key="index"
      >
        <div class="avatar-block">
          <img class="avatar"
               :src="item.avatar"
               :alt="item.name"
          />
        </div>
        <div class="info">
          <div class="user-name">{{ item.name }}</div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
      <img  class="liu-xuan-img"
            :src="require('@/assets/img/liuxuan-psychology/liuxuan.png')"
            alt="刘轩"
      />
    </div>
    <img class="question-btn"
         :src="require('@/assets/img/liuxuan-psychology/question_btn.png')"
         alt=""
    />
  </div>
</template>

<script>
  export default {
    name: 'LiuXuanQuestionList',
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .liu-xuan-question-list {
    margin: 150px auto 0;
    padding-bottom: 220px;
    max-width: 1100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .question-list {
    width: 1076px;
    min-height: 664px;
    padding: @size-medium 0 80px @size-extra-medium;
    box-sizing: border-box;
    background: url("~@/assets/img/liuxuan-psychology/question_content.png") repeat-y;
    background-size: contain;
    position: relative;
  }

  .liu-xuan-img {
    width: 346px;
    height: 664px;
    display: block;
    position: absolute;
    top: 0;
    right: 18px;
  }

  .question-item {
    width: 660px;
    padding-top: @size-medium;
    padding-bottom: @size-base;
    box-sizing: border-box;
    display: flex;
    border-bottom: 3px dotted #404087;
  }

  .avatar-block {
    flex-shrink: 0;
    width: 94px;
    height: 94px;
    margin-right: @size-small;
    padding: 2px 0 0 2px;
    background: url("~@/assets/img/liuxuan-psychology/avatar_bg.png") no-repeat;
    background-size: contain;
    overflow: hidden;
    .avatar {
      width: 82px;
      height: 82px;
      display: block;
      border-radius: 50%;
    }
  }

  .user-name {
    width: fit-content;
    margin-bottom: @size-base;
    padding: 0 14px 5px 14px;
    color: #404087;
    font-size: @font-size-small;
    font-weight: @font-weight-bold;
    position: relative;
    z-index: 1;
    line-height: 1;
    &:before {
      width: 100%;
      height: 16px;
      border-radius: 8px;
      content: '';
      background: #8DFFDB;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: -1;
    }
  }

  .content {
    padding-left: 14px;
    font-size: @font-size-extra-extra-small;
    color: @color-text-base;
    line-height: 1.4;
  }
</style>
